import { PaginatedResponse, PaginationParams } from '@console/utils';
import { apiClient } from './client';

export interface Company {
  id: string;
  name: string;
  remoteId?: string;
  createdAt: string;
  updatedAt: string;
}

export const companiesApi = {
  getAll: async (params?: PaginationParams): Promise<PaginatedResponse<Company>> => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.limit) searchParams.append('limit', params.limit.toString());

    const queryString = searchParams.toString();
    const response = await apiClient.get(`/companies${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  findByName: async (name: string): Promise<Company[]> => {
    const response = await apiClient.get(`/companies/search?name=${encodeURIComponent(name)}`);
    return response.data;
  },
};
